import { Boundaries } from "@planzone/core";
import { State } from "./types";

function handlePostCommentRequest(
  state: State,
  { discussion, comment }: Boundaries["postComment"]["request"],
): State {
  return state.map((result) =>
    result.discussion.uuid === discussion.uuid
      ? {
          ...result,
          discussion: {
            ...result.discussion,
            comments: [
              ...result.discussion.comments,
              {
                ...comment,
                uuid: `__pending__${comment.content}`,
                createdDate: new Date().toISOString(),
              },
            ],
          },
        }
      : result,
  );
}

export { handlePostCommentRequest };
